var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0156 1.66675H5.98229C4.20729 1.66675 2.76562 3.11675 2.76562 4.88341V16.6251C2.76562 18.1251 3.84063 18.7584 5.15729 18.0334L9.22396 15.7751C9.65729 15.5334 10.3573 15.5334 10.7823 15.7751L14.849 18.0334C16.1656 18.7667 17.2406 18.1334 17.2406 16.6251V4.88341C17.2323 3.11675 15.7906 1.66675 14.0156 1.66675Z",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmark);
export default __webpack_public_path__ + "static/media/icon_bookmark.e34ccf2d13230a1af65df6ea8fc7f5ab.svg";
export { ForwardRef as ReactComponent };